import { Button } from '@material-ui/core'
import React from 'react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'
import { CustomIframe } from '../../../components/shared/customIframe/customIframe'
import { NonAuthRoutes } from '../../../model'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../../redux'

export interface ClientsEditPageProps {}

export const ClientsEditPage: React.FC<any> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'clientsMod'])
  const history = useHistory()

  const [idCliente] = React.useState<number | undefined>(
    props.location.state !== undefined && props.location.state.idCliente !== undefined
      ? props.location.state.idCliente
      : undefined
  )

  const [activeTabPanel] = React.useState<string | undefined>(
    props.location.state !== undefined && props.location.state.activeTabPanel !== undefined
      ? props.location.state.activeTabPanel
      : undefined
  )
  // const apiSuffixUrl = 'https://localhost:44394';
  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()

  const getUrl = () => {
    let url = `${apiSuffixUrl}/clientes/userdata?idCliente=${idCliente}`
    if (activeTabPanel) {
      url = `${apiSuffixUrl}/clientes/userdata?idCliente=${idCliente}&activeTabPanel=${activeTabPanel}`
    }
    return url
  }

  const [routeLocal, setRouteLocal] = useState(getUrl())

  useEffect(() => {
    call()
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(getUrl())
    }, 1000)
  }

  return (
    <Page>
      <PageHeader title={t('clientsMod:clientsEdit')}>
        <Button
          variant="text"
          color="primary"
          onClick={() => {
            history.push(NonAuthRoutes.Client)
          }}
        >
          {t('clientsMod:buttons.back')}
        </Button>
      </PageHeader>
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
        button={true}
      />
    </Page>
  )
}
